import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Messages = () => {
    const { t } = useTranslation();
    return (
        <Box sx={{ maxWidth: 700, mx: "auto", mt: 4, mb: 4 }}>
            <Typography variant="h4" sx={{ mb: 3 }}>{t("menu.messages", "Messages")}</Typography>
            <Typography variant="body1" color="text.secondary">
                {t("messages.centerDescription", "This is your messages center. Feature coming soon.")}
            </Typography>
        </Box>
    );
};

export default Messages; 